import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";

import { message, Modal } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import QRCode_offLine from "@/assets/img/QRCode_offLine.png";
import { getQrCode } from "../Joyspace/api/page";
import NetworkCheck from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { useTranslation } from "react-i18next";
import { Loading } from "@jd/focus-desktop-comps";
import { downLoadFile, html2Canvas } from "@/utils/chat/index";
import { FocusSDK, isFocusEnv, useDebounce } from "@/utils";
import debounce from "lodash/debounce";
import CopyClipboard from "copy-to-clipboard";
import bus from "@/utils/bus";
import "./index.less";
import { generateTeamCode, refreshTeamCode } from "@/api/user";
import { changeEgovUrl } from "@/utils/tools";
interface joinTeamType {
  teamName: string;
  deptName: string;
  expireTime: string;
  qrCode: string;
  inviteCode: string;
  teamCode: string;
  avatar?: string;
  inviteUserName: string;
}
function JoinTeam(props: { teamId: string }) {
  const { teamId } = props;
  const [code, setCode] = useState("");
  const [data, setData] = useState<joinTeamType | null>(null);
  const [qrcodeUrl, setQrcodeUrl] = useState<any>(null);
  const [onSaving, setOnSaving] = useState<boolean>(false);
  const { t } = useTranslation("common");
  const { onGlobalError, service, focusSDK } = useContext<GlobalContextConfig>(GlobalContext);
  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl()
  });
  useEffect(() => {
    const reqFunc = refreshTeamCode;
    reqFunc({ teamId, type: "ALL" })
      .then((res) => {
        console.log("res>ls", res);
        setData(res);
        setCode(res.inviteCode);
        setQrcodeUrl(res.qrCode);
      })
      .catch((e) => {
        console.warn("error");
      });
  }, [teamId]);
  useEffect(() => {
    netServer.checkNet().then((res) => {
      console.log("网络检测==》", res);

      if (!res || !qrcodeUrl) {
        return;
      }
      // clone node
      let box1 = document.getElementById("qrModal");
      const copyDom = document.getElementById("qrModal_clone");
      copyDom && document.getElementById("qr-wrap")?.removeChild(copyDom);
      // 第一份儿深克隆
      let cloneDom: any = box1?.cloneNode(true);
      // 排版，不显示在页面上（不能用display:none，会导致无法生成url）
      cloneDom.setAttribute("style", "position: absolute;top: 0px; z-index: -1;");
      // 设置id（用于销毁，否则会导致页面重复生成table）
      cloneDom?.setAttribute("id", "qrModal_clone");
      cloneDom?.lastChild.setAttribute("style", "display: flex");
      document.getElementById("qr-wrap")?.append(cloneDom);
    });
  }, [qrcodeUrl]);
  const copyQrcode = useDebounce(function () {
    if (!qrcodeUrl || onSaving) return;
    setOnSaving(true);
    setTimeout(() => {
      const dom = document.getElementById("qrModal");
      if (dom) {
        html2Canvas(dom)
          .then(async (url) => {
            setOnSaving(false);
            if (!isFocusEnv()) {
              let a = document.createElement("a");
              a.download = "团队二维码.png";
              a.href = url;
              document.body.append(a); // 修复firefox中无法触发click
              a.click();
              URL.revokeObjectURL(a.href);
              a.remove();
            } else {
              downLoadFile("团队二维码.png", url);
            }
          })
          .catch(() => {
            setOnSaving(false);
            message.error(t("joinTeam.copyError"));
          });
      } else {
        setOnSaving(false);
        message.error(t("joinTeam.copyError"));
      }
    }, 60);
  }, 100);

  //   const copyQrcode = useDebounce(function () {
  //     if (!qrcodeUrl || onSaving) return;
  //     setOnSaving(true);
  //     setTimeout(() => {
  //       const dom = document.getElementById("qrModal");
  //       if (dom) {
  //         setOnSaving(true);
  //         html2Canvas(dom)
  //           .then(async (url) => {
  //             setOnSaving(false);
  //             console.log(url, "url>ls");
  //             let isOk = await FocusSDK.clipboardImage(url);
  //             isOk ? message.success("复制成功") : message.error("复制失败");
  //           })
  //           .catch(() => {
  //             setOnSaving(false);
  //             message.error("复制失败");
  //           });
  //       } else {
  //         setOnSaving(false);
  //         message.error("复制失败");
  //       }
  //     }, 60);
  //   }, 500);
  const copyCode = useCallback(() => {
    if (CopyClipboard(code)) {
      message.success("复制成功");
    }
  }, [code]);

  const contentNode = useMemo(() => {
    return (
      <div className="qr-space">
        <div id="qrModal">
          <div className="qr-title">{t("joinTeam.QrcodeTitle")}</div>
          <div className="qr-team-name">{data?.deptName}</div>

          <img src={changeEgovUrl(qrcodeUrl)} crossOrigin="anonymous" />

          <p className="qr-time">{t("joinTeam.time", { time: data?.expireTime })} </p>
        </div>
        <div className="qr-copy " onClick={copyQrcode}>
          {t("joinTeam.copyQrcode")}
        </div>
      </div>
    );
  }, [qrcodeUrl, teamId]);
  const codeNode = useMemo(() => {
    return (
      <div className="qr-space">
        <div className="qr-title">{t("joinTeam.codeTitle")}</div>
        <div className="qr-code">{code}</div>
        <div className="qr-copy" onClick={copyCode}>
          {t("joinTeam.copyCode")}
        </div>
      </div>
    );
  }, [code, t]);

  return (
    <div className="join-team-content-wrap">
      <div className="join-team-top"> {t("joinTeam.tips")}</div>
      <div className="join-team-content">
        <div className="code-wrap" id="qr-wrap">
          {contentNode}
        </div>
        <div className="code-wrap" id="code-wrap">
          {codeNode}
        </div>
        {onSaving ? (
          <div className="saving-wrap">
            <Loading />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default JoinTeam;
